import { ArrowDown01Icon } from '@hugeicons-pro/core-stroke-rounded';
import React from 'react';
import { Platform } from 'react-native';
import { useTranslation } from 'react-i18next';
import { Box } from '@/components/gluestack/box';
import { Text } from '@/components/gluestack/text';
import { VStack } from '@/components/gluestack/vstack';
import { HugeIconsWrapper } from '@/components/ui/HugeIconsWrapper';
import { useIsLargeScreen } from '@/hooks/useIsLargeScreen';

export function DiscoverTabBarHint() {
  const { t } = useTranslation();
  const isLargeScreen = useIsLargeScreen();

  if (isLargeScreen || Platform.OS === 'web') {
    return null;
  }

  return (
    <VStack className="-mb-6 mt-4 w-full items-center">
      <Box className="w-full max-w-sm rounded-t-xl bg-background-0 px-4 pb-3 pt-4">
        <VStack className="items-center gap-2">
          <Text size="md" bold className="text-center text-typography-700">
            {t('discover.tabBarHintLead')}
          </Text>
          <Text size="sm" className="text-center leading-5 text-typography-500">
            {t('discover.tabBarHintBody')}
          </Text>
        </VStack>
        <VStack className="mt-3 items-center">
          <HugeIconsWrapper icon={ArrowDown01Icon} size={28} className="color-tertiary-500" />
        </VStack>
      </Box>
    </VStack>
  );
}
